module.exports = __webpack_public_path__ + "assets/img/iDi_logo_extended_black_green.3f211612.svg";